import "./styles/user.less";
import React from "react";
import { connect } from "dva";
import { Layout } from "antd";
import { Switch, routerRedux } from 'dva/router';
import $$ from "cmn-utils";
const { Content } = Layout;

@connect()
export default class MobileLayout extends React.PureComponent {

  componentDidMount() {
  }

  componentWillMount() {
    // 检查有户是否登录
    const user = $$.getStore('user');
    if (!user) {
      this.props.dispatch(routerRedux.replace('/link/login'));
    } else {
    }
  }

  render() {
    const { routerData } = this.props;
    const { childRoutes } = routerData;
    return (
      <Layout className="full-layout user-layout fixed">
        <Content>
          <Switch>{childRoutes}</Switch>
        </Content>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/MobileLayout.js